import React, { useCallback } from 'react';

import ContentWrapper from '../Wrappers/ContentWrapper/ContentWrapper';
import { optionsDecorator, outputOptionsDecorator } from '../../utils';
import { discussionTopicOptions } from '../../constants';
import FormFields from './FormFields/FormFields';

type Props = {
  discussionTopics: Array<string>;
  advanceOnboardingState: Function;
};

function DiscussionTopics({ discussionTopics: intitialDiscussionTopics, advanceOnboardingState }: Props) {
  const handleNextStep = useCallback(
    ({ discussionTopics }) => advanceOnboardingState({ discussion_topics: outputOptionsDecorator(discussionTopics) }),
    [advanceOnboardingState]
  );

  return (
    <ContentWrapper
      initialValues={{
        discussionTopics: optionsDecorator({
          options: intitialDiscussionTopics,
          presetOptions: discussionTopicOptions,
        }),
      }}
      title="Discussion Topics"
      description="Discussion Items are like meeting agendas."
      onNextStep={handleNextStep}
    >
      <FormFields />
    </ContentWrapper>
  );
}

export default DiscussionTopics;
